import { defineStore } from "pinia";

export const useToPlayStore = defineStore("to-play", () => {
  const state = reactive({
    isMenuOpen: false,
    isGameModalOpen: false,
    activeGame: null,
  });

  function toggleMenu() {
    state.isMenuOpen = !state.isMenuOpen;
  }

  function toggleGameModal(param = false) {
    state.isGameModalOpen = param ? param : !state.isGameModalOpen;
  }

  return {
    state,

    toggleMenu,
    toggleGameModal,
  };
});
